export default [
  { text: "sexo.HOME", value: "HOME" },
  { text: "sexo.MULLER", value: "MULLER" },
];
